import { useContext } from "react";
import type { Message } from "~/components/SnackBar/SnackBar";
import {
	type SnackBarCloser,
	SnackBarContext,
	type SnackBarOpener,
} from "~/components/SnackBar/SnackBarProvider";

export const useSnackBar = (): [SnackBarOpener, SnackBarCloser] => {
	const ctx = useContext(SnackBarContext);

	// eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
	const defaultOpen: SnackBarOpener = (_message: Message) => {};

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	const defaultClose: SnackBarCloser = () => {};

	return [ctx?.open ?? defaultOpen, ctx?.close ?? defaultClose];
};
